<script setup lang="ts">
import { Product } from "~/models/Product"
import { useProductCardData } from "~/composables/ProductCardData"
import { capitalizeFirstLetter } from "~/common/helpers"
/**
 *
 *  Props and emits section
 *
 *
 */

const props = defineProps<{
    title: string
    subtitle: string
    variant: string
    image: string
    product: Product
}>()

const emits = defineEmits<{
    (e: "showProduct"): void
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const { add, show } = useProductCardData(props.product)

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */

const getCardStyles = () => {
    return props.variant === "primary"
        ? "tw-bg-customGray-200"
        : "tw-bg-secondary"
}

const getSubtitleStyles = () => {
    return props.variant === "primary"
        ? "tw-text-customGray-700"
        : "tw-text-white"
}

const getButtonStyles = () => {
    return props.variant === "primary"
        ? "tw-bg-secondary tw-text-white"
        : "tw-bg-white tw-text-customGray-700"
}

const addToCart = () => {
    add(props.product, 1)
}

const showProduct = () => {
    show(props.product)
}
</script>

<template>
    <div
        @click="showProduct"
        :class="`${getCardStyles()} tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-between md:tw-justify-around md:tw-flex-row tw-py-3 tw-px-4 md:tw-py-8 lg:tw-py-11 md:tw-rounded-[3px] tw-overflow-hidden`"
    >
        <div
            class="tw-flex tw-flex-col tw-justify-between lg:tw-h-full tw-gap-5 md:tw-pt-2 lg:tw-pt-5 md:tw-pb-6 lg:tw-pb-12"
        >
            <div>
                <p
                    class="tw-text-customGray-700 tw-uppercase tw-flex tw-flex-col tw-items-center md:tw-items-start"
                >
                    {{ title }}
                </p>
                <p
                    :class="`${getSubtitleStyles()} tw-font-medium tw-text-2xl tw-leading-9 tw-text-center md:tw-text-start`"
                >
                    {{ capitalizeFirstLetter(subtitle) }}
                </p>
            </div>
            <button
                :class="`${getButtonStyles()} tw-rounded-full tw-font-medium tw-leading-6 tw-h-10 tw-w-max tw-px-5 tw-mx-auto md:tw-mx-0`"
                @click="addToCart"
            >
                Comprar ahora
            </button>
        </div>
        <NuxtImg
            v-if="image"
            :src="image"
            alt=""
            format="png"
            class="tw-flex tw-w-[249px] tw-h-[178px] md:tw-w-[367px] md:tw-h-[262px] tw-bg-transparent"
        />
    </div>
</template>

<style scoped></style>
